import { EntityTypeShortForm } from "us.common/constants";
import { CaseTypes } from "us.common/constants";

/**
 * @function
 * @description If the object has a length greater than 0, return the object, otherwise return an empty array.
 * @param {any} data - any
 * @returns An array of any type or an empty array.
 */
export const getData = (data: any): any[] | [] => {
  try {
    return Object.keys(data).length > 0 ? data : [];
  } catch (e) {
    return [];
  }
};

/**
 * @function
 * @description Format archived search results
 * @param {any[]} data - endpoint response data
 * @returns Formatted data
 */
export const formatArchiveSearchResult = (data: Array<any>): object => {
  try {
    if (Array.isArray(data)) {
      const caseList: any = data?.filter(
        ({ caseType }: any) => caseType == EntityTypeShortForm.CASE
      );
      const invoiceList: any = data?.filter(
        ({ caseType }: any) => caseType != EntityTypeShortForm.CASE
      );

      return {
        caseList: caseList?.map((caseRecord: any) => {
          const { lastActivityName } = caseRecord ?? {};
          return {
            ...caseRecord,
            caseType: CaseTypes.CLOSED,
            lastMessageActivityName: lastActivityName,
          };
        }),
        invoiceList: invoiceList?.map((invoiceRecord: any) => {
          const { caseState, lastActivityName, invoiceRef } = invoiceRecord ?? {};
          return {
            ...invoiceRecord,
            invoiceNumber: invoiceRef,
            caseType: CaseTypes.CLOSED,
            subCaseState: caseState,
            lastMessageActivityName: lastActivityName,
          };
        }),
      };
    } else {
      return {
        caseList: [],
        invoiceList: [],
      };
    }
  } catch (e) {
    return {
      caseList: [],
      invoiceList: [],
    };
  }
};
